<template>
  <div class="bg-white w-48 rounded py-2 shadow-md">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
